import { createGlobalStyle } from "styled-components";
import { globalStyles } from "twin.macro";

const GlobalStyles = createGlobalStyle(
  globalStyles,
  `
   /* Below animations are for modal created using React-Modal */
     .ReactModal__Overlay {
     transition: transform 300ms ease-in-out;
     transition-delay: 100ms;
     transform: scale(0);
   }
   .ReactModal__Overlay--after-open{
     transform: scale(1);
   }
   .ReactModal__Overlay--before-close{
     transform: scale(0);
   }
    
   /* Background Container with Gradient */
.gradient-container {
  background-image: linear-gradient(120deg, #0c4d961f 0%, #8ec5fcc4 100%);
  border-radius: 12px;
  margin: 10px;
  padding: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .gradient-container {
    margin: 0px; /* Reduced margin */
    padding: 0.75rem; /* Reduced padding */
    border-radius: 8px; /* Smaller border radius */
  }
}

@media (max-width: 480px) {
  .gradient-container {
    margin: 0px; /* Minimal margin */
    padding: 0.5rem; /* Compact padding */
    border-radius: 5px; /* Even smaller border radius */
  }
}

  /* Force Noto Sans JP site-wide. <i> is intentionally excluded so that
     Font Awesome / icon fonts keep their own font-family. */
  body, h1, h2, h3, h4, h5, h6, p, a, span, div, input, textarea,
  button, select, li, ul, ol, table, td, th {
    font-family: "Noto Sans JP", sans-serif !important;
  }

  svg {
    justify-self: center !important;
  }

  /* Hide the ReactFlow attribution badge shown on the org chart. */
  .react-flow__attribution {
    display: none !important;
  }
`
);

export default GlobalStyles;
